import React, { FunctionComponent } from "react";

interface InfoItemProps {
  heading: string | React.ReactElement;
  content: string | string[];
  className?: string;
}

const InfoItem: FunctionComponent<InfoItemProps> = ({
  heading,
  content,
  className,
}) => (
  <div className={`infoItem ${className}`}>
    <h4 className="h4 ds-u-margin--0">{heading}</h4>
    {Array.isArray(content) ? (
      content.map((c, i) => (
        <p className="ds-text ds-u-margin--0" key={i}>
          {c}
        </p>
      ))
    ) : (
      <p className="ds-text">{content}</p>
    )}
  </div>
);

export default InfoItem;
